import colors from './colors';

export default function(css) {
  const success = {
    className: css`
      background: ${colors.lightGreen};
    `,
    bodyClassName: css`
      color: ${colors.veryDarkGreen};
      font-weight: bold;
    `,
    progressClassName: css`
      background: ${colors.darkGreen};
    `,
  };

  const defaultStyle = {
    className: css`
      background: ${colors.gray};
    `,
    bodyClassName: css`
      color: ${colors.black};
      font-weight: bold;
    `,
  };

  return {
    unsavedchanges: {
      className: css`
        background: ${colors.blue};
      `,
      bodyClassName: css`
        color: ${colors.veryLightBlue};
        font-weight: bold;
      `,
    },
    update: {
      className: css`
        background: ${colors.orange};
      `,
      bodyClassName: css`
        color: ${colors.white};
        font-weight: bold;
      `,
    },
    remove: {
      className: css`
        background: ${colors.red};
      `,
      bodyClassName: css`
        color: ${colors.white};
        font-weight: bold;
      `,
      progressClassName: css`
        background: ${colors.veryDarkRed};
      `,
    },
    outofstock: defaultStyle,
    defaultStyle,
    error: {
      className: css`
        background: ${colors.lightRed};
      `,
      bodyClassName: css`
        color: ${colors.veryDarkRed};
        font-weight: bold;
      `,
      progressClassName: css`
        background: ${colors.veryDarkRed};
      `,
    },
    orderTransmitted: success,
    success,
  };
}
